"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#80B1B9"; // teal
const logoPadding = 0;
const headerTextColor = "#003227"; //  really dark green
const appAccentColor = "#003227";
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const headerBackgroundColor = brand;
const style = "normal";
const colorAppBar = "#80B1B9";
const colorOnAppBar = "#003227";
const colorPrimary = "#80B1B9";
const colorPrimaryDarker = "#538e97";
const colorPrimaryLighter = "#e6eff1";
const colorOnPrimary = "#003227";
const colorSecondary = "#003227";
const colorOnSecondary = "#80B1B9";
const colorTiles = ["#80B1B9", "#80B1B9", "#80B1B9"];
exports.default = {
    logoPadding,
    brand,
    headerBackgroundColor,
    style,
    headerTextColor,
    appAccentColor,
    mainInfoLandscape,
    mainInfoPortrait,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
